export default {
	common: {
		close: "Close",
		save: "Save",
		edit: "Edit",
		confirm: "Confirm",
		cancel: "Cancel",
		back: "Back",
		loadMore: "Load more",
		noData: "No data",
		viewDetails: "View details",
		contactKefu: "Customer Support",
		copySuccess: "Copied",
		personalCenter: "Personal Center",
		yes: "Yes",
		no: "No",
	},
	default: {
		title: "My Files",
		addFile: "Add File",
		privacyTip:
			"Your information is strictly protected and only used to provide more accurate services",
	},
	baziFile: {
		empty: "No files",
		firstFileTitle: "Add your first file",
		name: "Name",
		namePlaceholder: "Enter name",
		gender: "Gender",
		birthDate: "Birth Date",
		birthDatePlaceholder: "Select your birth date",
		birthArea: "Birth place",
		birthAreaPlaceholder: "Please select region",
		livingArea: "Residence Area",
		livingAreaPlaceholder: "Please select region",
		relation: "Select your relationship",
		relationMine: "Me",
		relationFamily: "Family",
		relationFriend: "Friend",
		male: "Male",
		female: "Female",
		editTitle: "Edit Profile",
		solar: "Solar",
		lunar: "Lunar",
		nameRequired: "Please enter a name",
		genderRequired: "Please select a gender",
		birthDateRequired: "Please select your birth date",
		futureDateError: "Future dates cannot be selected",
		relationRequired: "Please select your relationship",
		deleteFile: "Delete File",
		deleteConfirm: "Delete this file?",
		confirmDelete: "Confirm Delete",
		deleteUnsupported: "Deleting files is not supported yet",
		inUse: "In Use",
	},
	coupon: {
		title: "My Coupons",
		unused: "Unused",
		used: "Used",
		expired: "Expired",
		empty: "No content",
		minimum: "Valid over {amount}",
		validUntil: "Valid until {date}",
		usageRules: "Usage rules",
		ruleTip:
			"Each coupon can only be used once and cannot be combined with other offers. Some products are excluded. See the usage instructions for details.",
	},
	follow: {
		title: "Favorites / Following",
		creatorCount: "Following creators {count}",
		likes: "Likes",
		followers: "Followers",
		shareCreator: "Share {name}",
		viewMore: "View more",
		viewsTenThousand: "{count}0K views",
		viewsCount: "{count} views",
		empty: "No followed content",
		latest: "Latest updates",
		recentFollowed: "Recently followed",
		demoVideoTitle:
			"Can destiny reveal a stable relationship pattern? Reading compatibility through the heavenly stems",
		demoViews: "12,586 views",
		demoDate: "2 days ago",
		demoCreatorName: "Zhao Zhenhong",
		demoCategory: "Relationships · Destiny Reading",
		demoDescription: "A highly experienced consultant",
	},
	message: {
		title: "My Messages",
		clearUnread: "Clear unread",
		notifyTitle: "Turn on notifications so you never miss important messages!",
		notifyDesc: "Enable browser notifications to receive the latest messages and offers",
		enableNotify: "Turn on",
		teacherMessages: "Mentor Messages",
		systemMessages: "System Messages",
		inService: "In service...",
		enterChat: "Enter chat",
		demoChatDate: "Dec 24  09:26",
		demoTeacherBubble: "Is this what you mean, or is it closer to that?",
		demoTeacherIntro1: "Mentor introduction copy goes here",
		demoTeacherIntro2: "More mentor introduction copy",
		demoUserBubble:
			"Mentor, I am not sure whether they still care about me. Could you help me check?",
		demoLinkPrefix: "Here is a linked Q&A:",
		demoServiceTip: "The mentor recommends a service:",
		demoServiceTitle: "Lifetime Career Reading",
		demoServiceDesc:
			"Everyone hopes to achieve something in life. No matter your field, success comes from using your strengths and making steady effort. Through your birth code, the mentor will help you...",
		demoOriginPrice: "Original price 2688 coins",
		orderNow: "Order now",
		demoOrderNotice:
			"Your order for the premium service “2026 Wealth Analysis” was placed successfully. Thank you for trusting the platform.",
		demoAgreementPrefix: "Please read ",
		demoAgreementLinks: "User Agreement, Privacy Policy, and Platform Service Notice",
		demoAgreementSuffix:
			". Continuing the consultation means you understand the relevant rules and risks and agree to the terms.",
		demoRiskNotice:
			"Obscene, abusive, or illegal speech is prohibited. To report an issue, go to Profile - Help Center - Live Support.",
		demoAddressNotice:
			"This service includes a product. Please provide a shipping address so it can be delivered. ",
		fillAddress: "Fill in address >>",
		inputPlaceholder: "Hello mentor, I would like to ask about a relationship crisis",
		send: "Send",
		demoTeacherSubtitle: "Bazi Reading · Feng Shui",
	},
	order: {
		title: "My Orders",
		searchPlaceholder: "Order No.",
		search: "Search",
		count: "{count} orders",
		goTo: "Go to",
		page: "page",
		notFoundTitle: "Can’t find your order?",
		reasonPrefix: "Possible reasons:",
		reasonAccount: "· A different email or account was used",
		reasonUnpaid: "· The order was not paid successfully",
		reasonCanceled: "· The order was canceled or expired",
		allOrders: "All Orders",
		paidTest: "Paid Readings",
		teacherConsult: "Mentor Consultations",
		voiceConsult: "Voice Consults",
		mallOrder: "Shop Orders",
		institutionOrder: "Institution Orders",
		otherOrder: "Other Orders",
		status: "Order Status",
		amount: "Order Amount",
		mallStatusPaid: "Paid",
		mallStatusRefunded: "Refunded",
		statusFilterAll: "All",
		statusFilterPaid: "Paid",
		statusFilterUnpaid: "Pending Payment",
		statusFilterCancelled: "Canceled / Refunded",
	},
	profile: {
		title: "My Profile",
		name: "Name",
		namePlaceholder: "Enter name",
		gender: "Gender",
		birthDate: "Birth Date",
		birthDatePlaceholder: "Select birth date",
		birthArea: "Birth place",
		birthAreaPlaceholder: "Please select region",
		livingArea: "Residence Area",
		livingAreaPlaceholder: "Please select region",
		email: "Email",
		emailPlaceholder: "Enter email",
		phone: "Phone",
		phonePlaceholder: "Enter phone number",
		goLink: "Link now",
		changeEmail: "Change email",
		changePhone: "Change phone",
		saveUnsupported: "Save API is not connected yet. Please provide the YApi documentation.",
		saveSuccess: "Saved successfully",
		saveFailed: "Save failed. Please try again.",
		avatarUploadFailed: "Avatar upload failed",
	},
	sidebar: {
		wallet: "My Wallet",
		needHelp: "Need help?",
		helpDesc: "If you have any questions, please contact support",
		monthlyMember: "Monthly Member",
		normalMember: "Regular Member",
		goodMorning: "Good morning",
		goodNoon: "Good afternoon",
		goodAfternoon: "Good afternoon",
		goodEvening: "Good evening",
		goodNight: "It is late. Remember to rest",
		coupon: "Coupons",
		address: "Address Management",
		profile: "Profile",
		account: "Account Info",
		logout: "Log Out",
	},
	logout: {
		title: "Are you sure you want to log out of Seerq?",
		confirmButton: "Log Out",
	},
	wallet: {
		totalAssets: "Total Balance",
		rechargeRecords: "Top-up History",
		rechargeAmount: "Top-up Amount",
		givingAmount: "Bonus Amount",
		selectAmount: "Select Top-up Amount",
		amountRate: "(1 point = 1 USD)",
		confirmRecharge: "Confirm Top-up",
		pointsBadge: "+{amount} points",
		agreementPrefix: "I have read and agree to the ",
		agreementLink: "Service Agreement",
		recordsEmpty: "No records yet",
		tabGiving: "Bonus Records",
		tabRecharge: "Top-up Records",
		tabConsume: "Spending Records",
		givingTag: "Bonus",
		validUntil: "Valid until: ",
		date: "{month}/{day}/{year}",
		dateTime: "{month}/{day}/{year} {hour}:{minute}",
		expired: "Expired",
		expiringSoon: "Expiring soon",
		rechargeSuccess: "Top-up successful",
		checkout: "Checkout",
		selectCurrency: "Select currency",
		selectPayment: "Select a payment method",
		more: "More",
		collapse: "Collapse",
		balance: "Balance:",
		payNow: "Pay now",
		paymentConfirmTitle: "Have you completed the payment?",
		paymentCompleted: "Completed",
		rechargeSuccessMessage: "Top-up successful",
		agreementRequired: "Please read and agree to the agreement first",
		paymentSuccess: "Payment successful",
		paymentNotFound: "Unable to find payment details. Please try again later.",
		checkingPayment: "Checking payment status, please wait...",
		balanceInsufficient: "Insufficient balance",
		paymentProcessing: "Processing payment",
		jumpPayFailed: "Failed to open the payment page. Please try again.",
		checkPayFailed: "Failed to check payment status. Please try again later.",
		selectPayArea: "Payment region",
		noCoupon: "No coupons available",
		discountedPrice: "Final price",
		originalPriceCoin: "Original {amount} points",
		payAreas: {
			china: "China",
			hongKongMacau: "Hong Kong/Macau",
			malaysia: "Malaysia",
			singapore: "Singapore",
			globalOtherUnknown: "Global Other/Unknown",
			taiwan: "Taiwan",
			indonesia: "Indonesia",
			vietnam: "Vietnam",
			thailand: "Thailand",
		},
		payMethods: {
			wechatPay: "WeChat Pay",
			stripe: "Stripe",
			paypal: "PayPal",
			alipay: "Alipay",
			newebPay: "NewebPay (CVS, Barcode, etc.)",
			tngWallet: "TNG e-Wallet",
			publicBank: "Public Bank",
			maybank: "Maybank Bank",
			ocbcBank: "OCBC Bank",
			myCard: "MyCard",
			linePay: "LinePay",
			points: "Points",
			creditCard: "Credit Card",
			globalCreditCard: "Global Credit Card Payment",
			macauCreditCard: "Macau Credit Card",
			taiwanLinePay: "Taiwan LinePay Payment",
		},
	},
	benefits: {
		title: "App-Exclusive Benefits",
		downloadTitle: "Ready to explore your life path?",
		downloadDesc: "Download the Seerq app now and start your journey of insight",
		downloadApk: "Download APK",
		downloadOnThe: "Download on the",
		googlePlay: "Google Play",
		appStore: "App Store",
		androidApk: "Android APK",
		beanLine1: "Collect Beans",
		beanLine2: "Redeem Prizes",
		vipLine1: "Free Trial",
		vipLine2: "Membership",
		blessingLine1: "Blessing Altar",
		blessingLine2: "Daily Blessings",
		liveLine1: "Mentor Live On-Call",
		liveLine2: "3 Free Minutes",
		meditationLine1: "Meditation Space",
		meditationLine2: "Daily Healing",
	},
	address: {
		title: "Address Management",
		addAddress: "Add Address",
		empty: "No address yet",
		formTitle: "Add / Edit Address",
		recipientName: "Recipient Name",
		recipientNamePlaceholder: "Enter recipient name",
		recipientNameRequired: "Please enter recipient name",
		recipientNameMax: "Recipient name cannot exceed 20 characters",
		contactPhone: "Contact Phone",
		contactPhonePlaceholder: "Enter contact phone",
		contactPhoneRequired: "Please enter contact phone",
		areaCodePlaceholder: "Area code",
		areaCodeRequired: "Please select area code",
		contactEmail: "Contact Email",
		contactEmailPlaceholder: "Enter contact email",
		contactEmailRequired: "Please enter contact email",
		postalCode: "Postal Code",
		postalCodePlaceholder: "Enter postal code",
		postalCodeHint: "e.g. 110",
		postalCodeRequired: "Please enter postal code",
		countryRegion: "Country / Region",
		countryRegionPlaceholder: "Please select region",
		countryRegionRequired: "Please select region",
		detailAddress: "Detailed Address",
		detailAddressPlaceholder: "Enter detailed address",
		detailAddressRequired: "Please enter detailed address",
		setDefault: "Set as default address",
		defaultAddress: "Default Address",
		copy: "Copy",
		modify: "Edit",
		deleteConfirm: "Delete this address?",
		deleteUnsupported: "Deleting addresses is not supported yet",
	},
};
